// extracted by mini-css-extract-plugin
export default {"title":"UsersAndAccounts_title__RNcjJ","header":"UsersAndAccounts_header__vE7P7","usersAndAccountsWrapper":"UsersAndAccounts_usersAndAccountsWrapper__uM7Me"};